import { ref, computed } from 'vue'

export interface Job {
  id?: number
  name: string
  completed: boolean
  project: number
  worker: number
  created: string
  args: string
  [key: string]: boolean | string | number | object | string[] | null | undefined
}

export function useJobs() {
  const jobs = ref<Job[]>([]) // items is now Ref<Job[]>
  let inFlightFetch: Promise<void> | null = null

  const getJobs = async (): Promise<Job[]> => {
    const response = await fetch('/api/jobs/')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Jobs')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchJobs = async () => {
    if (inFlightFetch) {
      return inFlightFetch
    }

    inFlightFetch = (async () => {
      jobs.value = await getJobs()
    })().finally(() => {
      inFlightFetch = null
    })

    return inFlightFetch
  }

  const jobKeys = computed(() => {
    const keys = jobs.value.length > 0 ? Object.keys(jobs.value[0]) : []
    // remove created and updated keys
    keys.splice(keys.indexOf('created'), 1)
    return keys
  })

  return { jobs, fetchJobs, jobKeys }
}